// src/components/dashboard/FilesPieChartCard.jsx
import React, { useEffect, useState } from 'react';
import { fetchStorageData } from '../../services/api.service';
import { getUsedPercentage } from '../../utils/storage.utils';
import { FilesChartLegend } from './ChartLegend';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const FilesPieChartCard = ({ maxSize }) => {
  const [fileSize, setFileSize] = useState(0);
  const [loading, setLoading] = useState(true);

  const COLORS = ['#00CC5C', '#e9ecef'];

  useEffect(() => {
    const load = async () => {
      try {
        const token = sessionStorage.getItem('authToken');
        const data = await fetchStorageData(token);

        const fileBucket = data.bucketSizes?.find(b => b.bucket === 'files') || { size: 0 };
        setFileSize(fileBucket.size);
      } catch (err) {
        console.error('Error loading files pie chart:', err);
        setFileSize(0);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const used = getUsedPercentage(fileSize, maxSize);

  const pieData = [
    { name: 'Used', value: used },
    { name: 'Available', value: 100 - used },
  ];

  return (
    <div className="card h-100 shadow">
      <div className="card-body">
        <h6 className="font-weight-bold text-uppercase mb-3">Files Storage Usage</h6>
        {loading ? (
          <div className="spinner-border text-success" role="status" />
        ) : (
          // Changed to always stack vertically - chart on top, legend at bottom
          <div className="d-flex flex-column align-items-center">
            {/* Chart container - centered at top */}
            <div className="chart-container mb-4" style={{ width: '100%', maxWidth: '300px' }}>
              <ResponsiveContainer width="100%" height={200}>
                <PieChart>
                  <Pie
                    data={pieData}
                    dataKey="value"
                    outerRadius={80}
                    innerRadius={50}
                    paddingAngle={2}
                  >
                    {pieData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index]} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
            
            {/* Legend container - full width at bottom */}
            <div className="w-100">
              <FilesChartLegend
                filesBucket={{ size: fileSize }}
                maxSize={maxSize}
                usedPercentage={used}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilesPieChartCard;